import React from 'react'
import PropTypes from 'prop-types'
import {Modal} from "../fModal/Modal";
import Moment from 'moment'
import { ReadOnly } from '../fCard/ButtonOutline/ReadOnly';

class Comments extends React.Component {

	state = {
		add: false
	}

	comment = React.createRef();

	render() {
		console.log(this.props);

		return (
			<div>
				{
					this.props.comments.map(item => {
						return (
							<div key={item.time} style={{
								borderBottom: '1px dotted var(--border-color)',
								padding: 12,
							}}>
								<p style={{ color: "var(--text-color)", fontSize: 17, fontWeight: 600, whiteSpace: "pre-wrap", wordBreak: "break-all" }}>
									{item.message}
								</p>
								<p style={{ color: "var(--light-color)", fontSize: 9 }}>
									Posted by {item.owner && item.owner.ownerName ? item.owner.ownerName : '-'} on {Moment(item.time).format("DD MMM YYYY hh:mm A")}
								</p>
							</div>
						)
					})
				}
				{
					this.props.comments.length === 0 ? <p style={{
						padding:12,
						fontSize:13,
						letterSpacing:1.25,
						marginTop:20,
					}}>No comment found</p> : undefined
				}

				{
					this.props.editable ?
						<ReadOnly>
							<p onClick={() => {
								this.setState({
									...this.state,
									add: true
								})
							}} style={{
								color: "var(--primary-color)",
								fontSize: 13,
								padding:12,
								letterSpacing:1.25,
								textTransform:'uppercase',
								cursor: 'pointer',
								fontWeight: 700
							}}>
								+ Add Comment
							</p>
						</ReadOnly> : undefined
				}
				{
					this.state.add ?
						<Modal style={{
							save: {
								background: "var(--primary-color)",
								width: "100%",
								border: "2px solid var(--primary-color)",
								padding: '12px 15px',
								textAlign: 'center'
							}
						}} title={"Add Comment"}
							des="Please enter a comment to add."
							onSave={() => {
								
								let comment = this.comment.current.value;
								if (comment) {
									this.setState({
										...this.state,
										add: false
									}, () => {
										this.props.add(comment)
									})
								}
							}} buttonName={'Add Comment'}
							show={true} close={() => {
								this.setState({ ...this.state, add: undefined })
							}}>
							<div style={{ display: 'flex', flexDirection: 'column'}}>
								<label className='floating-top-label' htmlFor='comment'>Comment:</label>
								<textarea rows={5} id='comment' name="Comment" type="text" ref={this.comment} placeholder='Enter your comment here...' style={{fontSize: 15, padding: 5, border: '1px solid var(--border-color)', borderRadius: 6, backgroundColor: 'var(--off-white)', width: '100%'}} />	
							</div>
						</Modal> : undefined
				}
			</div>
		)
	}

}

Comments.defaultProps = {
	editable: true
}

Comments.propTypes = {
	comments: PropTypes.array.isRequired,
	editable: PropTypes.bool,
	add: PropTypes.func
}

export default Comments
